import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/what-builderedu-does", label: "What BuilderEDU Does", testid: "nav-what-link" },
  { to: "/blueprint-for-success", label: "Blueprint for Success", testid: "nav-blueprint-link" },
  { to: "/connect", label: "Connect", testid: "nav-connect-link" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white border-b border-navy/10" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 shrink-0">
          <img src="/assets/builderedu-logo.png" alt="BuilderEDU" className="h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-head text-sm font-semibold uppercase tracking-[0.14em] transition-colors duration-200 ${
                  isActive ? "text-brand-dark" : "text-navy hover:text-brand-dark"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/connect"
            data-testid="nav-cta-button"
            className="font-head text-sm font-bold uppercase tracking-[0.12em] bg-brand text-navy-ink px-6 py-3 hover:bg-navy hover:text-white transition-colors duration-200"
          >
            Get Involved
          </Link>
        </nav>

        <button
          className="md:hidden text-navy p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-navy/10 bg-white px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `font-head text-base font-semibold uppercase tracking-[0.14em] ${
                  isActive ? "text-brand-dark" : "text-navy"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
